import { render, staticRenderFns } from "./skeleton_loader.vue?vue&type=template&id=6d09f426&scoped=true"
import script from "./skeleton_loader.vue?vue&type=script&lang=js"
export * from "./skeleton_loader.vue?vue&type=script&lang=js"
import style0 from "./skeleton_loader.vue?vue&type=style&index=0&id=6d09f426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09f426",
  null
  
)

export default component.exports